(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-home-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {

  const wrapper = document.querySelector('.responsive-image-hero-wrapper');
  const slides = document.querySelectorAll('.responsive-image-slide');

  const nextBtn = document.querySelector('.responsive-image-next');
  const prevBtn = document.querySelector('.responsive-image-prev');

  if (!wrapper || slides.length <= 1) return;

  let currentSlide = 0;
  const totalSlides = slides.length;

  function updateSlider(index) {

    if (index < 0) {
      index = totalSlides - 1;
    }

    if (index >= totalSlides) {
      index = 0;
    }

    currentSlide = index;

    wrapper.style.transform =
      `translateX(-${currentSlide * 100}%)`;
  }

  nextBtn.addEventListener('click', () => {
    updateSlider(currentSlide + 1);
  });

  prevBtn.addEventListener('click', () => {
    updateSlider(currentSlide - 1);
  });

  setInterval(() => {
    updateSlider(currentSlide + 1);
  }, 3000);

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const wrapper = document.querySelector('.hero-slider-wrapper');
    const slides = document.querySelectorAll('.hero-slide');
    const next = document.querySelector('.hero-next');
    const prev = document.querySelector('.hero-prev');
    if (!wrapper || !slides.length) return;

    // Hide arrows if only one slide
    if (slides.length <= 1) {
      next.style.display = 'none';
      prev.style.display = 'none';
    }

    // Slider logic
    let index = 0;
    const total = slides.length;
    function showSlide(i) {
      if (i < 0) i = total - 1;
      if (i >= total) i = 0;
      index = i;
      wrapper.style.transform = `translateX(-${i * 100}%)`;
    }

    next.addEventListener('click', () => showSlide(index + 1));
    prev.addEventListener('click', () => showSlide(index - 1));

    // Auto-slide
    let autoSlide = setInterval(() => showSlide(index + 1), 6000);

    // Swipe for mobile
    let startX = 0,
      endX = 0;
    wrapper.addEventListener(
      'touchstart',
      (e) => {
        startX = e.touches[0].clientX;
        clearInterval(autoSlide);
      },
      { passive: true }
    );
    wrapper.addEventListener('touchmove', (e) => (endX = e.touches[0].clientX), { passive: true });
    wrapper.addEventListener('touchend', () => {
      const diff = startX - endX;
      if (Math.abs(diff) > 50) showSlide(index + (diff > 0 ? 1 : -1));
      autoSlide = setInterval(() => showSlide(index + 1), 6000);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
